import {datesHelper} from "./dates.helper";

export const customerHelper = {
  validateField,
  checkCurrent,
  setCookie,
  _validateDniNie,
  _validateEmail,
  toForm
}

function _validateEmail(email){
  if (email.length === 0) return false
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function _validateDniNie(doc){
  const re = /(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))|(([a-b]|[A-B]{1})([-]?)(\d{8}))/g
  return re.test(doc)
}

function validateField(value, validators){

  let errors = []
  let response = {
    'result': true
  }
  validators.forEach(v => {
    let _key = Object.keys(v)[0]

    switch (_key) {
      case 'lon':
        if(value.length < parseInt(v[_key])){
          response.result = false
          errors.push('lon')
        }
        break
      case 'mail':
        if(!_validateEmail(value)){
          response.result = false
          errors.push('mail')
        }
        break
      case 'dni':
        if(value.length < parseInt(v[_key]) && !_validateDniNie(value)){
          response.result = false
          errors.push('dni')
        }
        break
      case 'edad':
        if(!datesHelper.isAdult(value)) {
          response.result = false
          errors.push('edad')
        }
        break
    }
  })
  if(!response.result) response['errors'] = errors


  return response
}

function checkCurrent(cname='user-token') {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  let rdo = '';
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      rdo = c.substring(name.length, c.length);
    }
  }
  return rdo;
}

function setCookie(token, eliminar=false){
  let now = null
  if(!eliminar) {
    now = new Date()
    let time = now.getTime()
    time += 3600 * 1000
    now.setTime(time)
  }else{
    now = new Date(1970,1,1,0,0,0)
  }

  document.cookie =
    'user-token=' + token +
    '; expires=' + now.toUTCString() +
    '; path=/';
}

function toForm(user){
  console.log(user)
  //delete user.id
  //delete user.username
  user['name'] = user.nombre
  delete user.nombre

  user['surname'] = user.apellidos
  delete user.apellidos

  user['confirmar'] = user.email

  user['phone'] = user.telefono
  delete user.telefono

  user['street'] = user.direccion
  delete user.direccion

  user['postcode'] = user.cp
  delete user.cp

  user['state'] = user.localidad
  delete user.localidad

  user['city'] = user.poblacion
  delete user.poblacion

  user['country'] = user.pais || "España"
  delete user.pais

  user['birthday'] = user.fechnac
  delete user.fechnac

  user['club'] = user.clubs
  delete user.clubs

  return user

}

export const countries = [
  "Afganistán",
  "Albania",
  "Alemania",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antártida",
  "Antigua y Barbuda",
  "Antillas Holandesas",
  "Arabia Saudí",
  "Argelia",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaiyán",
  "Bahamas",
  "Bahrein",
  "Bangladesh",
  "Barbados",
  "Bélgica",
  "Belice",
  "Benin",
  "Bermudas",
  "Bielorrusia",
  "Birmania",
  "Bolivia",
  "Bosnia y Herzegovina",
  "Botswana",
  "Brasil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Bután",
  "Cabo Verde",
  "Camboya",
  "Camerún",
  "Canadá",
  "Chad",
  "Chile",
  "China",
  "Chipre",
  "Ciudad del Vaticano (Santa Sede)",
  "Colombia",
  "Comores",
  "Congo",
  "Congo, República Democrática del",
  "Corea",
  "Corea del Norte",
  "Costa de Marfíl",
  "Costa Rica",
  "Croacia (Hrvatska)",
  "Cuba",
  "Dinamarca",
  "Djibouti",
  "Dominica",
  "Ecuador",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Eritrea",
  "Eslovenia",
  "España",
  "Estados Unidos",
  "Estonia",
  "Etiopía",
  "Fiji",
  "Filipinas",
  "Finlandia",
  "Francia",
  "Gabón",
  "Gambia",
  "Georgia",
  "Ghana",
  "Gibraltar",
  "Granada",
  "Grecia",
  "Groenlandia",
  "Guadalupe",
  "Guam",
  "Guatemala",
  "Guayana",
  "Guayana Francesa",
  "Guinea",
  "Guinea Ecuatorial",
  "Guinea-Bissau",
  "Haití",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irak",
  "Irán",
  "Irlanda",
  "Isla Bouvet",
  "Isla de Christmas",
  "Islandia",
  "Islas Caimán",
  "Islas Cook",
  "Islas de Cocos o Keeling",
  "Islas Faroe",
  "Islas Heard y McDonald",
  "Islas Malvinas",
  "Islas Marianas del Norte",
  "Islas Marshall",
  "Islas menores de Estados Unidos",
  "Islas Palau",
  "Islas Salomón",
  "Islas Svalbard y Jan Mayen",
  "Islas Tokelau",
  "Islas Turks y Caicos",
  "Islas Vírgenes (EEUU)",
  "Islas Vírgenes (Reino Unido)",
  "Islas Wallis y Futuna",
  "Israel",
  "Italia",
  "Jamaica",
  "Japón",
  "Jordania",
  "Kazajistán",
  "Kenia",
  "Kirguizistán",
  "Kiribati",
  "Kuwait",
  "Laos",
  "Lesotho",
  "Letonia",
  "Líbano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburgo",
  "Macedonia, Ex-República Yugoslava de",
  "Madagascar",
  "Malasia",
  "Malawi",
  "Maldivas",
  "Malí",
  "Malta",
  "Marruecos",
  "Martinica",
  "Mauricio",
  "Mauritania",
  "Mayotte",
  "México",
  "Micronesia",
  "Moldavia",
  "Mónaco",
  "Mongolia",
  "Montserrat",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Níger",
  "Nigeria",
  "Niue",
  "Norfolk",
  "Noruega",
  "Nueva Caledonia",
  "Nueva Zelanda",
  "Omán",
  "Países Bajos",
  "Panamá",
  "Papúa Nueva Guinea",
  "Paquistán",
  "Paraguay",
  "Perú",
  "Pitcairn",
  "Polinesia Francesa",
  "Polonia",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reino Unido",
  "República Centroafricana",
  "República Checa",
  "República de Sudáfrica",
  "República Dominicana",
  "República Eslovaca",
  "Reunión",
  "Ruanda",
  "Rumania",
  "Rusia",
  "Sahara Occidental",
  "Saint Kitts y Nevis",
  "Samoa",
  "Samoa Americana",
  "San Marino",
  "San Vicente y Granadinas",
  "Santa Helena",
  "Santa Lucía",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Seychelles",
  "Sierra Leona",
  "Singapur",
  "Siria",
  "Somalia",
  "Sri Lanka",
  "St Pierre y Miquelon",
  "Suazilandia",
  "Sudán",
  "Suecia",
  "Suiza",
  "Surinam",
  "Tailandia",
  "Taiwán",
  "Tanzania",
  "Tayikistán",
  "Territorios franceses del Sur",
  "Timor Oriental",
  "Togo",
  "Tonga",
  "Trinidad y Tobago",
  "Túnez",
  "Turkmenistán",
  "Turquía",
  "Tuvalu",
  "Ucrania",
  "Uganda",
  "Uruguay",
  "Uzbekistán",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Yugoslavia",
  "Zambia",
  "Zimbabue"]

export const provinces = [
  'Albacete',
  'Alicante/Alacant',
  'Almería',
  'Araba/Álava',
  'Asturias',
  'Ávila',
  'Badajoz',
  'Balears, Illes',
  'Barcelona',
  'Bizkaia',
  'Burgos',
  'Cáceres',
  'Cádiz',
  'Cantabria',
  'Castellón/Castelló',
  'Ceuta',
  'Ciudad Real',
  'Córdoba',
  'Coruña, A',
  'Cuenca',
  'Gipuzkoa',
  'Gerona',
  'Granada',
  'Guadalajara',
  'Huelva',
  'Huesca',
  'Jaén',
  'León',
  'Lérida',
  'Lugo',
  'Madrid',
  'Málaga',
  'Melilla',
  'Murcia',
  'Navarra',
  'Ourense',
  'Palencia',
  'Palmas, Las',
  'Pontevedra',
  'Rioja, La',
  'Salamanca',
  'Santa Cruz de Tenerife',
  'Segovia',
  'Sevilla',
  'Soria',
  'Tarragona',
  'Teruel',
  'Toledo',
  'Valencia/València',
  'Valladolid',
  'Zamora',
  'Zaragoza'
]
export const prefixes = 
{
  "Afganistán": "93",
  "Albania": "355",
  "Alemania": "49",
  "Andorra": "376",
  "Angola": "244",
  "Antártida": "672",
  "Arabia Saudita": "966",
  "Argelia": "213",
  "Argentina": "54",
  "Armenia": "374",
  "Aruba": "297",
  "Australia": "61",
  "Austria": "43",
  "Azerbaiyán": "994",
  "Bélgica": "32",
  "Bahrein": "973",
  "Bangladesh": "880",
  "Barbados": "1 246",
  "Belice": "501",
  "Benín": "229",
  "Bhután": "975",
  "Bielorrusia": "375",
  "Birmania": "95",
  "Bolivia": "591",
  "Bosnia y Herzegovina": "387",
  "Botsuana": "267",
  "Brasil": "55",
  "Brunéi": "673",
  "Bulgaria": "359",
  "Burkina Faso": "226",
  "Burundi": "257",
  "Cabo Verde": "238",
  "Camboya": "855",
  "Camerún": "237",
  "Canadá": "1",
  "Chad": "235",
  "Chile": "56",
  "China": "86",
  "Chipre": "357",
  "Ciudad del Vaticano": "39",
  "Colombia": "57",
  "Comoras": "269",
  "República del Congo": "242",
  "República Democrática del Congo": "243",
  "Corea del Norte": "850",
  "Corea del Sur": "82",
  "Costa de Marfil": "225",
  "Costa Rica": "506",
  "Croacia": "385",
  "Cuba": "53",
  "Curazao": "5999",
  "Dinamarca": "45",
  "Ecuador": "593",
  "Egipto": "20",
  "El Salvador": "503",
  "Emiratos Árabes Unidos": "971",
  "Eritrea": "291",
  "Eslovaquia": "421",
  "Eslovenia": "386",
  "España": "34",
  "Estados Unidos": "1",
  "Estonia": "372",
  "Etiopía": "251",
  "Filipinas": "63",
  "Finlandia": "358",
  "Fiyi": "679",
  "Francia": "33",
  "Gabón": "241",
  "Gambia": "220",
  "Georgia": "995",
  "Ghana": "233",
  "Gibraltar": "350",
  "Grecia": "30",
  "Groenlandia": "299",
  "Guadalupe": "590",
  "Guatemala": "502",
  "Guayana Francesa": "594",
  "Guernsey": "44",
  "Guinea": "224",
  "Guinea Ecuatorial": "240",
  "Guinea-Bissau": "245",
  "Guyana": "592",
  "Haití": "509",
  "Honduras": "504",
  "Hong kong": "852",
  "Hungría": "36",
  "India": "91",
  "Indonesia": "62",
  "Irán": "98",
  "Irak": "964",
  "Irlanda": "353",
  "Isla de Man": "44",
  "Isla de Navidad": "61",
  "Isla Norfolk": "672",
  "Islandia": "354",
  "Islas Cocos (Keeling)": "61",
  "Islas Cook": "682",
  "Islas de Åland": "358",
  "Islas Feroe": "298",
  "Islas Georgias del Sur y Sandwich del Sur": "500",
  "Islas Maldivas": "960",
  "Islas Malvinas": "500",
  "Islas Marshall": "692",
  "Islas Pitcairn": "870",
  "Islas Salomón": "677",
  "Israel": "972",
  "Italia": "39",
  "Japón": "81",
  "Jersey": "44",
  "Jordania": "962",
  "Kazajistán": "7",
  "Kenia": "254",
  "Kirguistán": "996",
  "Kiribati": "686",
  "Kuwait": "965",
  "Líbano": "961",
  "Laos": "856",
  "Lesoto": "266",
  "Letonia": "371",
  "Liberia": "231",
  "Libia": "218",
  "Liechtenstein": "423",
  "Lituania": "370",
  "Luxemburgo": "352",
  "México": "52",
  "Mónaco": "377",
  "Macao": "853",
  "Macedônia": "389",
  "Madagascar": "261",
  "Malasia": "60",
  "Malawi": "265",
  "Mali": "223",
  "Malta": "356",
  "Marruecos": "212",
  "Martinica": "596",
  "Mauricio": "230",
  "Mauritania": "222",
  "Mayotte": "262",
  "Micronesia": "691",
  "Moldavia": "373",
  "Mongolia": "976",
  "Montenegro": "382",
  "Mozambique": "258",
  "Namibia": "264",
  "Nauru": "674",
  "Nepal": "977",
  "Nicaragua": "505",
  "Niger": "227",
  "Nigeria": "234",
  "Niue": "683",
  "Noruega": "47",
  "Nueva Caledonia": "687",
  "Nueva Zelanda": "64",
  "Omán": "968",
  "Países Bajos": "31",
  "Pakistán": "92",
  "Palau": "680",
  "Palestina": "970",
  "Panamá": "507",
  "Papúa Nueva Guinea": "675",
  "Paraguay": "595",
  "Perú": "51",
  "Polinesia Francesa": "689",
  "Polonia": "48",
  "Portugal": "351",
  "Puerto Rico": "1",
  "Qatar": "974",
  "Reino Unido": "44",
  "República Centroafricana": "236",
  "República Checa": "420",
  "República de Sudán del Sur": "211",
  "Reunión": "262",
  "Ruanda": "250",
  "Rumanía": "40",
  "Rusia": "7",
  "Sahara Occidental": "212",
  "Samoa": "685",
  "San Bartolomé": "590",
  "San Marino": "378",
  "San Pedro y Miquelón": "508",
  "Santa Elena": "290",
  "Santo Tomé y Príncipe": "239",
  "Senegal": "221",
  "Serbia": "381",
  "Seychelles": "248",
  "Sierra Leona": "232",
  "Singapur": "65",
  "Siria": "963",
  "Somalia": "252",
  "Sri lanka": "94",
  "Sudáfrica": "27",
  "Sudán": "249",
  "Suecia": "46",
  "Suiza": "41",
  "Surinám": "597",
  "Svalbard y Jan Mayen": "47",
  "Swazilandia": "268",
  "Tayikistán": "992",
  "Tailandia": "66",
  "Taiwán": "886",
  "Tanzania": "255",
  "Territorio Británico del Océano Índico": "246",
  "Timor Oriental": "670",
  "Togo": "228",
  "Tokelau": "690",
  "Tonga": "676",
  "Tunez": "216",
  "Turkmenistán": "993",
  "Turquía": "90",
  "Tuvalu": "688",
  "Ucrania": "380",
  "Uganda": "256",
  "Uruguay": "598",
  "Uzbekistán": "998",
  "Vanuatu": "678",
  "Venezuela": "58",
  "Vietnam": "84",
  "Wallis y Futuna": "681",
  "Yemen": "967",
  "Yibuti": "253",
  "Zambia": "260",
  "Zimbabue": "263"
  }

  export const postal_codes = {
    '02': 'Albacete',
    '03': 'Alicante/Alacant',
    '04': 'Almería',
    '01': 'Araba/Álava',
    '33': 'Asturias',
    '05': 'Ávila',
    '06': 'Badajoz',
    '07': 'Balears, Illes',
    '08': 'Barcelona',
    '48': 'Bizkaia',
    '09': 'Burgos',
    '10': 'Cáceres',
    '11': 'Cádiz',
    '39': 'Cantabria',
    '12': 'Castellón/Castelló',
    '51': 'Ceuta',
    '13': 'Ciudad Real',
    '14': 'Córdoba',
    '15': 'Coruña, A',
    '16': 'Cuenca',
    '17': 'Gerona',
    '18': 'Granada',
    '19': 'Guadalajara',
    '20': 'Gipuzkoa',
    '21': 'Huelva',
    '22': 'Huesca',
    '23': 'Jaen',
    '24': 'León',
    '25': 'Lérida',
    '27': 'Lugo',
    '28': 'Madrid',
    '29': 'Málaga',
    '52': 'Melilla',
    '30': 'Murcia',
    '31': 'Navarra',
    '32': 'Ourense',
    '34': 'Palencia',
    '35': 'Palmas, Las',
    '36': 'Pontevedra',
    '26': 'Rioja, La',
    '37': 'Salamanca',
    '38': 'Santa Cruz de Tenerife',
    '40': 'Segovia',
    '41': 'Sevilla',
    '42': 'Soria',
    '43': 'Tarragona',
    '44': 'Teruel',
    '45': 'Toledo',
    '46': 'Valencia/València',
    '47': 'Valladolid',
    '49': 'Zamora',
    '50': 'Zaragoza'
  }

  export const country_iso = 
  {
    "Afganistán": "af",
    "Albania": "al",
    "Alemania": "de",
    "Andorra": "ad",
    "Angola": "ao",
    "Anguila": "ai",
    "Antártida": "aq",
    "Antigua y Barbuda": "ag",
    "Arabia Saudita": "sa",
    "Argelia": "dz",
    "Argentina": "ar",
    "Armenia": "am",
    "Aruba": "aw",
    "Australia": "au",
    "Austria": "at",
    "Azerbaiyán": "az",
    "Bélgica": "be",
    "Bahamas": "bs",
    "Bahrein": "bh",
    "Bangladesh": "bd",
    "Barbados": "bb",
    "Belice": "bz",
    "Benín": "bj",
    "Bhután": "bt",
    "Bielorrusia": "by",
    "Birmania": "mm",
    "Bolivia": "bo",
    "Bosnia y Herzegovina": "ba",
    "Botsuana": "bw",
    "Brasil": "br",
    "Brunéi": "bn",
    "Bulgaria": "bg",
    "Burkina Faso": "bf",
    "Burundi": "bi",
    "Cabo Verde": "cv",
    "Camboya": "kh",
    "Camerún": "cm",
    "Canadá": "ca",
    "Chad": "td",
    "Chile": "cl",
    "China": "cn",
    "Chipre": "cy",
    "Ciudad del Vaticano": "va",
    "Colombia": "co",
    "Comoras": "km",
    "República del Congo": "cg",
    "República Democrática del Congo": "cd",
    "Corea del Norte": "kp",
    "Corea del Sur": "kr",
    "Costa de Marfil": "ci",
    "Costa Rica": "cr",
    "Croacia": "hr",
    "Cuba": "cu",
    "Curazao": "cw",
    "Dinamarca": "dk",
    "Dominica": "dm",
    "Ecuador": "ec",
    "Egipto": "eg",
    "El Salvador": "sv",
    "Emiratos Árabes Unidos": "ae",
    "Eritrea": "er",
    "Eslovaquia": "sk",
    "Eslovenia": "si",
    "España": "es",
    "Estados Unidos de América": "us",
    "Estonia": "ee",
    "Etiopía": "et",
    "Filipinas": "ph",
    "Finlandia": "fi",
    "Fiyi": "fj",
    "Francia": "fr",
    "Gabón": "ga",
    "Gambia": "gm",
    "Georgia": "ge",
    "Ghana": "gh",
    "Gibraltar": "gi",
    "Granada": "gd",
    "Grecia": "gr",
    "Groenlandia": "gl",
    "Guadalupe": "gp",
    "Guam": "gu",
    "Guatemala": "gt",
    "Guayana Francesa": "gf",
    "Guernsey": "gg",
    "Guinea": "gn",
    "Guinea Ecuatorial": "gq",
    "Guinea-Bissau": "gw",
    "Guyana": "gy",
    "Haití": "ht",
    "Honduras": "hn",
    "Hong kong": "hk",
    "Hungría": "hu",
    "India": "in",
    "Indonesia": "id",
    "Irán": "ir",
    "Irak": "iq",
    "Irlanda": "ie",
    "Isla Bouvet": "bv",
    "Isla de Man": "im",
    "Isla de Navidad": "cx",
    "Isla Norfolk": "nf",
    "Islandia": "is",
    "Islas Bermudas": "bm",
    "Islas Caimán": "ky",
    "Islas Cocos (Keeling)": "cc",
    "Islas Cook": "ck",
    "Islas de Åland": "ax",
    "Islas Feroe": "fo",
    "Islas Georgias del Sur y Sandwich del Sur": "gs",
    "Islas Heard y McDonald": "hm",
    "Islas Maldivas": "mv",
    "Islas Malvinas": "fk",
    "Islas Marianas del Norte": "mp",
    "Islas Marshall": "mh",
    "Islas Pitcairn": "pn",
    "Islas Salomón": "sb",
    "Islas Turcas y Caicos": "tc",
    "Islas Ultramarinas Menores de Estados Unidos": "um",
    "Islas Vírgenes Británicas": "vg",
    "Islas Vírgenes de los Estados Unidos": "vi",
    "Israel": "il",
    "Italia": "it",
    "Jamaica": "jm",
    "Japón": "jp",
    "Jersey": "je",
    "Jordania": "jo",
    "Kazajistán": "kz",
    "Kenia": "ke",
    "Kirguistán": "kg",
    "Kiribati": "ki",
    "Kuwait": "kw",
    "Líbano": "lb",
    "Laos": "la",
    "Lesoto": "ls",
    "Letonia": "lv",
    "Liberia": "lr",
    "Libia": "ly",
    "Liechtenstein": "li",
    "Lituania": "lt",
    "Luxemburgo": "lu",
    "México": "mx",
    "Mónaco": "mc",
    "Macao": "mo",
    "Macedônia": "mk",
    "Madagascar": "mg",
    "Malasia": "my",
    "Malawi": "mw",
    "Mali": "ml",
    "Malta": "mt",
    "Marruecos": "ma",
    "Martinica": "mq",
    "Mauricio": "mu",
    "Mauritania": "mr",
    "Mayotte": "yt",
    "Micronesia": "fm",
    "Moldavia": "md",
    "Mongolia": "mn",
    "Montenegro": "me",
    "Montserrat": "ms",
    "Mozambique": "mz",
    "Namibia": "na",
    "Nauru": "nr",
    "Nepal": "np",
    "Nicaragua": "ni",
    "Niger": "ne",
    "Nigeria": "ng",
    "Niue": "nu",
    "Noruega": "no",
    "Nueva Caledonia": "nc",
    "Nueva Zelanda": "nz",
    "Omán": "om",
    "Países Bajos": "nl",
    "Pakistán": "pk",
    "Palau": "pw",
    "Palestina": "ps",
    "Panamá": "pa",
    "Papúa Nueva Guinea": "pg",
    "Paraguay": "py",
    "Perú": "pe",
    "Polinesia Francesa": "pf",
    "Polonia": "pl",
    "Portugal": "pt",
    "Puerto Rico": "pr",
    "Qatar": "qa",
    "Reino Unido": "gb",
    "República Centroafricana": "cf",
    "República Checa": "cz",
    "República Dominicana": "do",
    "República de Sudán del Sur": "ss",
    "Reunión": "re",
    "Ruanda": "rw",
    "Rumanía": "ro",
    "Rusia": "ru",
    "Sahara Occidental": "eh",
    "Samoa": "ws",
    "Samoa Americana": "as",
    "San Bartolomé": "bl",
    "San Cristóbal y Nieves": "kn",
    "San Marino": "sm",
    "San Martín (Francia)": "mf",
    "San Pedro y Miquelón": "pm",
    "San Vicente y las Granadinas": "vc",
    "Santa Elena": "sh",
    "Santa Lucía": "lc",
    "Santo Tomé y Príncipe": "st",
    "Senegal": "sn",
    "Serbia": "rs",
    "Seychelles": "sc",
    "Sierra Leona": "sl",
    "Singapur": "sg",
    "Sint Maarten": "sx",
    "Siria": "sy",
    "Somalia": "so",
    "Sri lanka": "lk",
    "Sudáfrica": "za",
    "Sudán": "sd",
    "Suecia": "se",
    "Suiza": "ch",
    "Surinám": "sr",
    "Svalbard y Jan Mayen": "sj",
    "Swazilandia": "sz",
    "Tayikistán": "tj",
    "Tailandia": "th",
    "Taiwán": "tw",
    "Tanzania": "tz",
    "Territorio Británico del Océano Índico": "io",
    "Territorios Australes y Antárticas Franceses": "tf",
    "Timor Oriental": "tl",
    "Togo": "tg",
    "Tokelau": "tk",
    "Tonga": "to",
    "Trinidad y Tobago": "tt",
    "Tunez": "tn",
    "Turkmenistán": "tm",
    "Turquía": "tr",
    "Tuvalu": "tv",
    "Ucrania": "ua",
    "Uganda": "ug",
    "Uruguay": "uy",
    "Uzbekistán": "uz",
    "Vanuatu": "vu",
    "Venezuela": "ve",
    "Vietnam": "vn",
    "Wallis y Futuna": "wf",
    "Yemen": "ye",
    "Yibuti": "dj",
    "Zambia": "zm",
    "Zimbabue": "zw"
    }


// WEBPACK FOOTER //
// ./src/_helpers/customer.helper.js